const CountrySelect_init = require("./CountrySelect_init");

module.exports = function Form_init(form) {
    const countrySelect = form.querySelector('[name="Country"]');

    if (countrySelect instanceof HTMLSelectElement) {
        CountrySelect_init(countrySelect);
    }
}